import { Model, MapTo } from 'src/app/decorators/mapto';
import { environment } from 'src/environments/environment';

export class MemberRoles extends Model {
    @MapTo()
    id: string;
    @MapTo()
    role: string;
    @MapTo()
    userrole_id: number;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}

export class MembersModel extends Model {
    @MapTo()
    id: string;
    @MapTo()
    user_id: string;
    @MapTo()
    first_name: string;
    @MapTo()
    last_name: string;
    @MapTo()
    email: string;
    @MapTo()
    display: string;
    @MapTo()
    phone_number: string;
    @MapTo()
    cnic: any;
    @MapTo('profile_image')
    image: any;
    @MapTo('roles')
    role: MemberRoles[];
    @MapTo()
    status: number;
    @MapTo()
    is_discount: boolean;
    @MapTo()
    rate: number;
    notAvailable: 'N/A';

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }

    delete() {
        this.status = 0;
    }

    get MemberId(): string {
        return this.id ? this.id : null;
    }

    get Image() {
        return (this.image = this.image ? this.image : environment.defualtThumbnail);
    }

    get FirstName(): string {
        return this.first_name ? this.first_name : this.notAvailable;
    }

    get LastName(): string {
        return this.last_name ? this.last_name : this.notAvailable;
    }

    get FullName(): string {
        return this.display ? this.display : this.notAvailable;
    }

    get CNIC(): string {
        return this.cnic ? this.cnic : this.notAvailable;
    }

    get ContactNumber(): string {
        return this.phone_number ? this.phone_number : this.notAvailable;
    }

    get Email(): string {
        return this.email ? this.email : this.notAvailable;
    }

    get IsDiscount(): boolean {
        return this.is_discount ? this.is_discount : false;
    }

    get DiscountRate(): number {
        return this.rate ? this.rate : null;
    }

    get Status(): number {
        return this.status ? this.status : null;
    }

    get UserRoleStatus(): number {
        let userRole;
        this.role.map((userrole) => {
            if (userrole) {
                userRole = userrole.id;
            }
        });
        return userRole || 0;
    }

    get UserRole(): string {
        let userRole;
        this.role.map((userrole) => {
            if (userrole) {
                userRole = userrole.role;
            }
        });
        return userRole || this.notAvailable;
    }

    get UserRoleId(): number {
        let userRole;
        this.role.map((userrole) => {
            if (userrole) {
                userRole = userrole.id;
            }
        });
        return userRole || null;
    }

    get MemberDisplay(): string {
        return this.display;
    }

    get RoleId(): number {
        return this.role[0].userrole_id || null;
    }
}
